export const LINE_ID = "ttm.service";
export const LINE_URL = `http://line.me/ti/p/~${LINE_ID}`;
export const LINE_QR_IMAGE = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(LINE_URL)}`;
